import { default as XHR } from 'i18next-xhr-backend';
import i18next from 'i18next';
export const i18n = (translationsApi, keys) => {
    const translationsUrl = new URL(translationsApi, location.origin);
    if (keys) {
        keys.forEach((key) => {
            translationsUrl.searchParams.append('keys', key);
        });
        void i18next.use(XHR).init({
            backend: {
                loadPath: translationsUrl,
            },
            keySeparator: '::',
        });
        return i18next;
    }
    void i18next.init({});
    return i18next;
};
export const sitecoreTranslation = (value) => (Object.assign(Object.assign({}, value), { interpolation: {
        prefix: '{',
        suffix: '}',
    } }));
